import { Tabs } from "antd";
import { useState } from "react";
import styled from "styled-components";

const StyledTabs = styled(Tabs)`
  .ant-tabs-nav {
    margin: 0;
    display: flex;
    justify-content: center;
    background-color: ${(props) => props.$navBg || "white"};
    padding: 20px 0 0 0;
    border-radius: 16px;
    border: 1px solid #e8e8e8;
    overflow: hidden;
  }

  .ant-tabs-nav::before {
    display: none !important;
  }

  .ant-tabs-nav-list {
    display: flex;
    width: 100%;
    justify-content: space-around;
    padding-bottom: 10px;
  }

  .ant-tabs-tab {
    flex: 1;
    justify-content: center;
    text-align: center;
    display: flex;
    align-items: center;
    padding: 0;
  }

  .ant-tabs-tab-active {
    color: ${(props) => props.$inkBarColor || "var(--color-secondary)"} !important;
    font-weight: bold;
    font-size: 14px;
  }

  .ant-tabs-ink-bar {
    background-color: ${(props) => props.$inkBarColor || "var(--color-secondary)"} !important;
    height: 5px !important;
    border-radius: 5px !important;
    opacity: 1 !important;
    box-shadow: none !important;
    filter: none !important;
  }

  .ant-tabs-content-holder {
    margin-top: 32px;
  }
`;

export const TabbarComponent = ({
  tabs = [],
  navBg,
  inkBarColor,
  contentBg,
  style,
}) => {
  const [activeKey, setActiveKey] = useState("1");

  // Agrega números, etiquetas y flechas a las tabs
  const tabsWithSteps = tabs.map((tab, index) => ({
    ...tab,
    label: (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            position: "relative",
          }}
        >
          {/* Círculo con el número */}
          <div
            style={{
              width: "24px",
              height: "24px",
              borderRadius: "50%",
              backgroundColor: tab.key === activeKey ? "var(--color-secondary)" : "#d9d9d9", // Activo o inactivo
              color: tab.key === activeKey ? "white" : "black",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontWeight: "bold",
            }}
          >
            {index + 1}
          </div>
          <span>{tab.label}</span>

          {/* Flecha solo si no es la última tab */}
          {index < tabs.length - 1 && (
            <div
              style={{
                position: "absolute",
                right: "-16px",
                top: "50%",
                transform: "translateY(-50%)",
                width: "0",
                height: "0",
                borderTop: "8px solid transparent",
                borderBottom: "8px solid transparent",
                borderLeft: "8px solid #d9d9d9", // Color de la flecha
              }}
            ></div>
          )}
        </div>
      </div>
    ),
  }));

  return (
    <StyledTabs
      defaultActiveKey="1"
      items={tabsWithSteps} // Usa las tabs con números y flechas
      $navBg={navBg}
      $inkBarColor={inkBarColor}
      $contentBg={contentBg}
      onChange={(key) => setActiveKey(key)}
      style={{ ...style }}
    />
  );
};
